<template>
    <div
        v-if="showMode === 'select'"
        class="cp input combobox"
        :class="[errorStatus? 'is-error': '']"
        :style="style"
        :data-error="errorMsg"
        :disabled="disabled"
    >
        <label v-if="hideLabel !== true" v-html="showLabel"></label>
        <a @click.prevent.stop="toggle" :disabled="disabled">{{ showDate }}</a>
        <transition name="animate">
            <ul class="func" v-if="show && option.length" @click.stop>
                <li
                    v-for="(item, index) in option"
                    :key="item.prop"
                >
                    <div class="cp input checkbox">
                        <input type="checkbox" :id="'check-'+ index +'-'+ item.prop" v-model="item.value">
                        <label :for="'check-'+ index +'-'+ item.prop">{{ item.name }}</label>
                    </div>
                </li>
            </ul>
        </transition>
    </div>
    <div
        v-else
        class="cp input combobox is-block"
        :class="[errorStatus? 'is-error': '']"
        :style="style"
        :data-error="errorMsg"
    >
        <label v-if="hideLabel !== true" v-html="showLabel"></label>
        <ul class="block">
            <li
                v-for="(item, index) in option"
                :key="item.prop"
            >
                <div class="cp input checkbox">
                    <input type="checkbox" :id="'check-'+ index +'-'+ item.prop" v-model="item.value">
                    <label :for="'check-'+ index +'-'+ item.prop">{{ item.name }}</label>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex'

    export default {
        props: {
            showMode: { //顯示模式 select or block
                type: String,
                require: false,
                default: 'select'
            },
            nullString: {
                type: String,
                require: false,
                default: ''
            },
            label: {
                type: String,
                require: false,
                default: ''
            },
            options: { //可以是 Object 也可以是 Array
                require: true,
                validator: function(prop) {
                    let _result = false;

                    if( Array.isArray(prop) || typeof prop === 'object' ) {
                        _result = true;
                    }

                    return _result;
                }
            },
            errorStatus: {
                type: Boolean,
                require: false
            },
            errorMsg: {
                type: String,
                require: false
            },
            hideLabel: {
                type: Boolean,
                require: false
            },
            value: {
                type: String,
                require: false,
                default: ''
            },
            disabled: {
                type: Boolean,
                require: false
            }
        },
        data: function(){

            return {
                option: [],
                show: false
            }
        },
        computed: {
            showDate: function() {
                let $result = [];

                let _value = this.value,
                    $value = _value.split(',');

                let $option = this.option;

                $value.forEach(value => {
                    let $target = $option.find(option => {
                            return option.prop === value;
                        });

                    if( $target ) {
                        $result.push($target.name);
                    }
                });

                if( $result.length ){
                    return $result.join(', ');
                }else {
                    return this.nullString || this.$t('site.noun.select');
                }
            },
            showLabel: function() {

                if( this.label ) {
                    return this.label;
                }else {
                    return this.$t('popup.select.item.multiselect');
                }
            },
            style: function(){

                if( this.show ) {
                    return {
                        'z-index': 5
                    }
                }else {
                    return {};
                }
            }
        },
        watch: {
            options: {
                handler: function(){
                    this.setOption();
                },
                deep: true
            },
            option: {
                handler: function(){
                    this.setValue();
                    this.$emit('change');
                },
                deep: true
            }
        },
        methods: {
            ...mapMutations([
                'globalClickFuncQueuePush',
                'globalClickFuncQueueRun',
                'globalClickFuncQueueClear'
            ]),
            toggle: function(){
                this.globalClickFuncQueueRun(this.id);
                this.show = !this.show;
                this.setOption();
            },
            hide: function(){
                this.show = false;
            },
            setValue: function(evt){
                let $option = this.option,
                    $value = [];

                $option.forEach(item => {

                    if( item.value ) {
                        $value.push(item.prop);
                    }
                });

                this.returnValue($value.join(','));
            },
            returnValue: function(value){
                this.$emit('input', value);
            },
            setOption: function() {
                let $options = this.options,
                    $value = this.value.split(',');

                let $result = [];

                if( Array.isArray($options) ) {

                    $options.forEach(item => {
                        let _value = $value.includes(item);

                        $result.push({
                            prop: item,
                            name: item,
                            value: _value
                        });
                    });

                }else if( typeof $options === 'object' ) {

                    for( let _key in $options ) {
                        let _name = $options[_key],
                            _value = $value.includes(_key);

                        $result.push({
                            prop: _key,
                            name: _name,
                            value: _value
                        });
                    }
                }

                this.$set(this, 'option', $result);
            }
        },
        created: function(){
            this.setOption();

            this.globalClickFuncQueuePush({
                id: this.id,
                func: this.hide
            });
        },
        destroyed: function(){
            this.globalClickFuncQueueClear(this.id);
        }
    }
</script>

<style scoped lang="scss">
    .animate-enter-active {
        animation: animate-in .3s;
    }

    .animate-leave-active {
        animation: animate-out .2s;
    }

    @keyframes animate-in {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    @keyframes animate-out {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }
</style>
